import type { Serializable } from './getStringifiedCopyPath';
import { getStringifiedCopyPath } from './getStringifiedCopyPath';

export const getCopyText = (obj: Serializable): string => {
  if (obj instanceof Date) {
    return obj.toString();
  }
  return getStringifiedCopyPath(obj);
};
